import { useQuery } from "@tanstack/react-query";
import { WalletService } from "@/services/wallet.service";
import { useTranslation } from "react-i18next";

export const useFetchTaxes = ({
  type,
  enabled = true,
  currency,
}: {
  type: string;
  enabled?: boolean;
  currency: string;
}) => {
  const { t } = useTranslation('common');

  const {
    data: taxes,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery({
    queryKey: ['wallet-taxes', type, currency],
    queryFn: async () => {
      const validType = type === 'international' ? 'international' : 'national';
      return await WalletService.getTaxes(validType, currency);
    },
    enabled,
  });

  return {
    taxes,
    isLoading,
    refetch,
    isRefetching,
    error: error ? (error as Error).message || t('data_listing_error') : null,
  };
};
